"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertButtonColor = void 0;
exports.parseDisclaimerText = parseDisclaimerText;
var _react = _interopRequireDefault(require("react"));
var _colors = _interopRequireDefault(require("../colors"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Helpers for the Contentful WebForm

// Contentful WebForm
// Terms and Conditions (TC) and Privacy Policy (PP) replacement.
// This looks for [TC] or [PP] in a disclaimer string and replaces them with a URL.
function parseDisclaimerText(sourceText) {
  if (!sourceText || sourceText === "") {
    return "";
  }
  if (typeof sourceText !== "string" || !sourceText.includes("[TC]") || !sourceText.includes("[PP]")) {
    return sourceText;
  }
  var firstArray = sourceText.split('[TC]');
  var tcArray = [firstArray[0], "[TC]", firstArray[1]];
  var ppArray = tcArray.map(function (phrase) {
    if (phrase.includes('[PP]')) {
      var m = phrase.split('[PP]');
      return [m[0], '[PP]', m[1]];
    }
    return phrase;
  });

  //const finalElementsArray = ppArray.flat().map( word => {
  // The 'reduce' and 'concat' replaces 'flat'. The 'flat' caused error on team city build for go.claytonhomes.
  var finalElementsArray = ppArray.reduce(function (acc, val) {
    return acc.concat(val);
  }, []).map(function (word) {
    if (word === "[TC]") {
      return /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.claytonhomes.com/legal/"
      }, "Terms & Conditions");
    }
    if (word === "[PP]") {
      return /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.claytonhomes.com/privacy/"
      }, "Privacy Policy");
    }
    return /*#__PURE__*/_react["default"].createElement("span", null, word);
  });
  return finalElementsArray;
}

// Convert hex color code text from Contentful to a Smokey color.
var convertButtonColor = exports.convertButtonColor = function convertButtonColor(hexCode) {
  switch (hexCode) {
    case '#0075c9':
      return _colors["default"].primary.claytonBlue;
    case '#352269':
      return _colors["default"].secondary.summerNight;
    case '#00b0ac':
      return _colors["default"].secondary.kiddiePool;
    case '#ef4b5d':
      return _colors["default"].accent.ladyBug;
    case '#ffffff':
      return _colors["default"].primary.white;
    case '#004b8d':
      return _colors["default"].accent.darkBlue;
    case '#4f9e44':
      return _colors["default"].accent.freshGrass;
    case '#37862c':
      return _colors["default"].accent.freshGrass.highContrast;
    default:
      return _colors["default"].primary.claytonBlue;
  }
};